import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [isEmailFocused, setIsEmailFocused] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative mt-10 md:mt-20 overflow-hidden">
      {/* Background with gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-900 via-gray-950 to-black"></div>

      {/* Animated Orbs */}
      <div className="absolute top-0 left-1/4 w-48 md:w-96 h-48 md:h-96 bg-yellow-500/5 rounded-full blur-3xl animate-blob"></div>
      <div className="absolute bottom-0 right-1/4 w-48 md:w-96 h-48 md:h-96 bg-amber-500/5 rounded-full blur-3xl animate-blob" style={{ animationDelay: '3s' }}></div>

      {/* Top Border Glow */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-500/50 to-transparent"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-12 py-10 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-10 md:mb-16">
          <div className="md:col-span-6 scroll-animate">
            <h3 className="text-lg md:text-2xl lg:text-3xl font-light text-white mb-3 md:mb-4 leading-snug">Se você é cliente e fez recurso conosco e precisa de atendimento, acesse o site abaixo</h3>
            <p className="text-sm md:text-base text-gray-400 mb-6 md:mb-8 leading-relaxed">
              www.centraldamulta.app.br
            </p>
          </div>

          <div className="md:col-span-3 scroll-animate delay-100">
            <h4 className="text-xs font-semibold text-yellow-500 mb-4 md:mb-6 tracking-wider">NAVEGAÇÃO</h4>
            <ul className="space-y-3 md:space-y-5">
              {['Funcionalidades', 'Planos', 'Suporte', 'Contato'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(item.toLowerCase())}
                    className="text-sm md:text-base text-gray-400 hover:text-yellow-400 transition-all duration-300 cursor-pointer relative group"
                  >
                    <span>{item}</span>
                    <span className="absolute bottom-0 left-0 w-0 h-px bg-yellow-500 group-hover:w-full transition-all duration-300"></span>
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3 scroll-animate delay-200">
            <h4 className="text-xs font-semibold text-yellow-500 mb-4 md:mb-6 tracking-wider">FALE CONOSCO</h4>
            <p className="text-lg md:text-2xl text-white mb-1 md:mb-2 hover:text-yellow-400 transition-colors duration-300 cursor-pointer">(11) 9 6415-7039</p>
            <p className="text-xs md:text-base text-gray-400 mb-6 md:mb-12 hover:text-yellow-400 transition-colors duration-300 cursor-pointer whitespace-nowrap overflow-hidden text-ellipsis">contato@centraldamulta.app.br</p>

            <h4 className="text-xs font-semibold text-yellow-500 mb-4 md:mb-6 tracking-wider">ENDEREÇO</h4>
            <p className="text-sm md:text-base text-gray-400 leading-relaxed">
              São Paulo, SP<br />
              Brasil
            </p>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-6 md:pt-8">
          <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between md:gap-6">
            <div className="flex items-center justify-center md:justify-start gap-4 md:gap-6">
              {['LinkedIn', 'Instagram', 'YouTube'].map((social) => (
                <a
                  key={social}
                  href={`https://${social.toLowerCase()}.com`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xs md:text-base text-gray-400 hover:text-yellow-400 transition-all duration-300 relative group"
                >
                  <span>{social}</span>
                  <span className="absolute bottom-0 left-0 w-0 h-px bg-yellow-500 group-hover:w-full transition-all duration-300"></span>
                </a>
              ))}
            </div>

            <p className="text-gray-500 text-xs md:text-sm text-center">© 2025 Central da Multa. Todos os direitos reservados.</p>

            <div className="flex items-center justify-center md:justify-end gap-4 md:gap-6 flex-wrap">
              <a href="#" className="text-gray-500 hover:text-yellow-400 transition-all duration-300 text-xs md:text-sm relative group">
                <span>Política de Privacidade</span>
                <span className="absolute bottom-0 left-0 w-0 h-px bg-yellow-500 group-hover:w-full transition-all duration-300"></span>
              </a>
              <a href="#" className="text-gray-500 hover:text-yellow-400 transition-all duration-300 text-xs md:text-sm relative group">
                <span>Termos de Uso</span>
                <span className="absolute bottom-0 left-0 w-0 h-px bg-yellow-500 group-hover:w-full transition-all duration-300"></span>
              </a>
              <a
                href="https://readdy.ai/?ref=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-500 hover:text-yellow-400 transition-all duration-300 text-xs md:text-sm relative group"
              >
                <span>Powered by Readdy</span>
                <span className="absolute bottom-0 left-0 w-0 h-px bg-yellow-500 group-hover:w-full transition-all duration-300"></span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
